export default "__VITE_ASSET__lK25NHmz__"